import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://evermin.in";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Per-route SEO: unique <title>, description, canonical + OG/Twitter mirrors.
// `noindex` keeps private/authenticated pages out of search results.
export function Seo({ title, description, noindex = false, path }) {
  const location = useLocation();
  const url = SITE + (path || location.pathname);

  useEffect(() => {
    const full = title ? `${title} — EVERMIN` : "EVERMIN — Make Every Minute Count";
    document.title = full;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setCanonical(url);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
  }, [title, description, noindex, url]);

  return null;
}
